<script>
import IconFileDownload from './icons/IconFileDownload.vue'
import IconTag from './icons/IconTag.vue'
import IconCottage from './icons/IconCottage.vue'
import IconCottageOutline from './icons/IconCottageOutline.vue'
import IconThumbUp from './icons/IconThumbUp.vue'
import IconThumbDown from './icons/IconThumbDown.vue'
import IconLogout from './icons/IconLogout.vue'
import IconLogin from './icons/IconLogin.vue'
import IconNewReleases from './icons/IconNewReleases.vue'
import IconSchool from './icons/IconSchool.vue'
import IconContactSupport from './icons/IconContactSupport.vue'
import IconHome from './icons/IconHome.vue'
import IconHomeOutline from './icons/IconHomeOutline.vue'
import IconPeople from './icons/IconPeople.vue'
import IconSettings from './icons/IconSettings.vue'
import IconInsightEdit from './icons/IconInsightEdit.vue'
import IconInsightAdd from './icons/IconInsightAdd.vue'
import IconInsight from './icons/IconInsight.vue'
import IconImportExport from './icons/IconImportExport.vue'
import IconDone from './icons/IconDone.vue'
import IconTrendingFlat from './icons/IconTrendingFlat.vue'
import IconMMSOutline from './icons/IconMMSOutline.vue'
import IconAnnouncement from './icons/IconAnnouncement.vue'
import IconPanorama from './icons/IconPanorama.vue'
import IconLock from './icons/IconLock.vue'
import IconPriorityHigh from './icons/IconPriorityHigh.vue'
import IconQuote from './icons/IconQuote.vue'
import IconCodeblock from './icons/IconCodeblock.vue'
import IconCode from './icons/IconCode.vue'
import IconHelpOutline from './icons/IconHelpOutline.vue'
import IconOpenInNew from './icons/IconOpenInNew.vue'
import IconNotifications from './icons/IconNotifications.vue'
import IconBrokenImage from './icons/IconBrokenImage.vue'
import IconNoImage from './icons/IconNoImage.vue'
import IconMovie from './icons/IconMovie.vue'
import IconRedo from './icons/IconRedo.vue'
import IconUndo from './icons/IconUndo.vue'
import IconPhoto from './icons/IconPhoto.vue'
import IconLink from './icons/IconLink.vue'
import IconListNumbered from './icons/IconListNumbered.vue'
import IconListBulleted from './icons/IconListBulleted.vue'
import IconStrikethrough from './icons/IconStrikethrough.vue'
import IconItalic from './icons/IconItalic.vue'
import IconBold from './icons/IconBold.vue'
import IconParagraph from './icons/IconParagraph.vue'
import IconHeading1 from './icons/IconHeading1.vue'
import IconHeading2 from './icons/IconHeading2.vue'
import IconDeleteOutline from './icons/IconDeleteOutline.vue'
import IconRefresh from './icons/IconRefresh.vue'
import IconChatOutline from './icons/IconChatOutline.vue'
import IconChatBubbleOutline from './icons/IconChatBubbleOutline.vue'
import IconNotInterested from './icons/IconNotInterested.vue'
import IconArrowUp from './icons/IconArrowUp.vue'
import IconArrowDown from './icons/IconArrowDown.vue'
import IconArrowLeft from './icons/IconArrowLeft.vue'
import IconArrowRight from './icons/IconArrowRight.vue'
import IconArrowDropUp from './icons/IconArrowDropUp.vue'
import IconArrowDropDrown from './icons/IconArrowDropDrown.vue'
import IconStar from './icons/IconStar.vue'
import IconStarBorder from './icons/IconStarBorder.vue'
import IconStarList from './icons/IconStarList.vue'
import IconNotes from './icons/IconNotes.vue'
import IconIosMenu from './icons/IconIosMenu.vue'
import IconAdd from './icons/IconAdd'
import IconEditOutline from './icons/IconEditOutline'
import IconEditNote from './icons/IconEditNote'
import IconRemove from './icons/IconRemove'
import IconClose from './icons/IconClose'
import IconInfoOutline from './icons/IconInfoOutline'
import IconExpandLess from './icons/IconExpandLess'
import IconExpandMore from './icons/IconExpandMore'
import IconFeedSource from './icons/IconFeedSource'
import IconFilterList from './icons/IconFilterList'
import IconWarning from './icons/IconWarning'
import IconSearch from './icons/IconSearch'
import IconChart from './icons/IconChart'
import IconSync from './icons/IconSync'
import IconSyncDisabled from './icons/IconSyncDisabled'
import IconHandle from './icons/IconHandle'
import IconRSS from './icons/feeds/IconRSS'
import IconTwitter from './icons/feeds/IconTwitter'
import IconYoutube from './icons/feeds/IconYoutube'
import IconVimeo from './icons/feeds/IconVimeo'
import IconChannel from './icons/feeds/IconChannel'
import IconAcceso from './icons/feeds/IconAcceso'
import IconNewsletter from './icons/feeds/IconNewsletter'
import IconMedium from './icons/feeds/IconMedium'
import IconSlideshare from './icons/feeds/IconSlideshare'
import IconReddit from './icons/feeds/IconReddit'
import IconTelegram from './icons/feeds/IconTelegram'
import IconSmartSearch from './icons/feeds/IconSmartSearch'
import IconLanguage from './icons/feeds/IconLanguage'
import IconPipe from './icons/feeds/IconPipe'

function resolveComponent(icon) {
  if (icon === 'fileDownload') return IconFileDownload
  if (icon === 'tag') return IconTag
  if (icon === 'handle') return IconHandle
  if (icon === 'cottage') return IconCottage
  if (icon === 'cottageOutline') return IconCottageOutline
  if (icon === 'logout') return IconLogout
  if (icon === 'login') return IconLogin
  if (icon === 'newReleases') return IconNewReleases
  if (icon === 'school') return IconSchool
  if (icon === 'contactSupport') return IconContactSupport
  if (icon === 'home') return IconHome
  if (icon === 'homeOutline') return IconHomeOutline
  if (icon === 'thumbUp') return IconThumbUp
  if (icon === 'thumbDown') return IconThumbDown
  if (icon === 'people') return IconPeople
  if (icon === 'settings') return IconSettings
  if (icon === 'insightEdit') return IconInsightEdit
  if (icon === 'insightAdd') return IconInsightAdd
  if (icon === 'insight') return IconInsight
  if (icon === 'importExport') return IconImportExport
  if (icon === 'done') return IconDone
  if (icon === 'trendingFlat') return IconTrendingFlat
  if (icon === 'mmsOutline') return IconMMSOutline
  if (icon === 'announcement') return IconAnnouncement
  if (icon === 'panorama') return IconPanorama
  if (icon === 'priorityHigh') return IconPriorityHigh
  if (icon === 'lock') return IconLock
  if (icon === 'pipe') return IconPipe
  if (icon === 'openInNew') return IconOpenInNew
  if (icon === 'notifications') return IconNotifications
  if (icon === 'helpOutline') return IconHelpOutline
  if (icon === 'code') return IconCode
  if (icon === 'codeblock') return IconCodeblock
  if (icon === 'quote') return IconQuote
  if (icon === 'h2') return IconHeading2
  if (icon === 'h1') return IconHeading1
  if (icon === 'paragraph') return IconParagraph
  if (icon === 'bold') return IconBold
  if (icon === 'italic') return IconItalic
  if (icon === 'strikethrough') return IconStrikethrough
  if (icon === 'listBulleted') return IconListBulleted
  if (icon === 'listNumbered') return IconListNumbered
  if (icon === 'link') return IconLink
  if (icon === 'photo') return IconPhoto
  if (icon === 'undo') return IconUndo
  if (icon === 'redo') return IconRedo
  if (icon === 'movie') return IconMovie
  if (icon === 'noImage') return IconNoImage
  if (icon === 'brokenImage') return IconBrokenImage
  if (icon === 'deleteOutline') return IconDeleteOutline
  if (icon === 'refresh') return IconRefresh
  if (icon === 'chatBubbleOutline') return IconChatBubbleOutline
  if (icon === 'chatOutline') return IconChatOutline
  if (icon === 'notInterested') return IconNotInterested
  if (icon === 'arrowUp') return IconArrowUp
  if (icon === 'arrowDown') return IconArrowDown
  if (icon === 'arrowLeft') return IconArrowLeft
  if (icon === 'arrowRight') return IconArrowRight
  if (icon === 'arrowDropUp') return IconArrowDropUp
  if (icon === 'arrowDropDown') return IconArrowDropDrown
  if (icon === 'star') return IconStar
  if (icon === 'starBorder') return IconStarBorder
  if (icon === 'starList') return IconStarList
  if (icon === 'notes') return IconNotes
  if (icon === 'iosMenu') return IconIosMenu
  if (icon === 'add') return IconAdd
  if (icon === 'editOutline') return IconEditOutline
  if (icon === 'editNote') return IconEditNote
  if (icon === 'remove') return IconRemove
  if (icon === 'close') return IconClose
  if (icon === 'info-outline') return IconInfoOutline
  if (icon === 'expandLess') return IconExpandLess
  if (icon === 'expandMore') return IconExpandMore
  if (icon === 'feedSource') return IconFeedSource
  if (icon === 'filterList') return IconFilterList
  if (icon === 'warning') return IconWarning
  if (icon === 'chart') return IconChart
  if (icon === 'search') return IconSearch
  if (icon === 'sync') return IconSync
  if (icon === 'syncDisabled') return IconSyncDisabled
  if (icon === 'rss') return IconRSS
  if (icon === 'twitter') return IconTwitter
  if (icon === 'youtube') return IconYoutube
  if (icon === 'vimeo') return IconVimeo
  if (icon === 'channel') return IconChannel
  if (icon === 'acceso') return IconAcceso
  if (icon === 'newsletter') return IconNewsletter
  if (icon === 'slideshare') return IconSlideshare
  if (icon === 'reddit') return IconReddit
  if (icon === 'telegram') return IconTelegram
  if (icon === 'medium') return IconMedium
  if (icon === 'lmsearch') return IconSmartSearch
  if (icon === 'watson') return IconSmartSearch // TODO:
  if (icon === 'language') return IconLanguage
  throw new TypeError('Unrecognized Icon name: ' + icon)
}

export default {
  name: 'LmIcon',
  functional: true,
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '24px'
    }
  },
  render(createElement, context) {
    context.data.props = context.props
    return createElement(
      resolveComponent(context.props.icon),
      context.data,
      context.children
    )
  }
}
</script>
